import { render, staticRenderFns } from "./Giphy.vue?vue&type=template&id=e0ddd560&scoped=true&"
import script from "./Giphy.vue?vue&type=script&lang=js&"
export * from "./Giphy.vue?vue&type=script&lang=js&"
import style0 from "./Giphy.vue?vue&type=style&index=0&id=e0ddd560&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0ddd560",
  null
  
)

export default component.exports